import Link from "next/link";
import Image from "next/future/image";
import { capabilitiesNav, industriesNav } from "../utils/data";
import DpiitBadge from "./trust/DpiitBadge";

export default function Footer() {
  // Extra capabilities shown only in footer
  const footerOnlyCapabilities = [
    {
      name: "Agentic AI Servies & Solutions",
      link: "/services/agentic-ai",
    },
    {
      name: "AI Strategy For Business",
      link: "/outcomes",
    },
    {
      name: "Startup Solutions",
      link: "/startup",
    },
    {
      name: "Data Centre Readiness",
      link: "/services/data-center-project-readiness-governance",
    },
  ];

  // Combine both for footer — hub leads the Services group as the flagship practice
  const capabilitiesFooter = [
    {
      name: "Custom Software Development",
      link: "/services/custom-software-development",
    },
    ...capabilitiesNav,
    ...footerOnlyCapabilities,
  ];

  return (
    <section>
      <footer id="contact-us" className="bg-[#1e1e1e] text-center text-white px-[20px] md:px-[50px] mx-auto py-10">
        {/* Logo Section */}
        <div className="flex w-full items-center justify-between flex-wrap gap-4 md:w-[92%] mx-auto">
          <Link href="/">
            <div className="mb-4 flex items-start text-2xl items-center cursor-pointer text-white hover:text-opacity-[0.7] font-bold mt-2">
              <div className="w-6 mr-2">
                <Image src="/logo.png" alt="logo" height="51" width="30" />
              </div>
              itmtb
            </div>
          </Link>
          <DpiitBadge variant="dark" />
        </div>

        {/* Navigation Links */}
        <div className="grid grid-cols-2 md:grid-cols-5 gap-y-10 gap-x-10 my-8">
          {[capabilitiesFooter, industriesNav, productsNav, generalPage, contactLinks].map((navList, idx) => (
            <div key={idx} className="flex flex-col space-y-2 items-start md:mx-auto">
              <p className="text-[20px] mb-1 font-semibold text-gray-100/40">
                {navList[0]?.category || (idx === 0 ? "Capabilities" : "")}
              </p>
              {navList.map(item => (
                <Link key={item.link} href={item.link}>
                  <a
                    target={item.link.includes("https:") ? "_blank" : "_self"}
                    rel={item.link.includes("https:") ? "noopener" : undefined}
                    className="text-left text-sm md:text-md hover:opacity-[0.6] cursor-pointer text-white"
                  >
                    {item.name}
                  </a>
                </Link>
              ))}
            </div>
          ))}
        </div>

        {/* Contact Info */}
        <div className="text-left my-10 sm:ml-4">
          <p className="text-gray-100/40">Locations</p>
          Pune | Bhopal
          <p className="text-gray-100/40">Email</p>
          hello@itmtb.com
        </div>

        {/* Copyright */}
        <p className="text-sm">Copyright © {new Date().getFullYear()} Itmtb Technologies Private Limited</p>
      </footer>
    </section>
  );
}

// Footer-specific lists

const contactLinks = [
  {
    name: "Contact Us",
    link: "/contact-us",
    category: "Get in Touch",
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/company/itmtb/",
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/itmtbtech/",
  },
];

const productsNav = [
  {
    name: "Orchestrik",
    link: "https://orchestrik.ai",
    category: "Products",
  },
  {
    name: "Tomorrow Central",
    link: "/tomorrow-central",
    category: "Products",
  },
  {
    name: "Enterprise Search",
    link: "/enterprise-search",
    category: "Products",
  },
];

const generalPage = [
  {
    name: "About Us",
    link: "/discover-itmtb",
    category: "Others",
  },
  {
    name: "Agents at Work",
    link: "/agents-at-work",
  },
  {
    name: "Privacy Policy",
    link: "/privacy_policy.html",
  },
  {
    name: "Careers",
    link: "/career",
  },
];

// import Link from "next/link";
// import Image from "next/future/image";
// import { capabilitiesNav, industriesNav } from "../utils/data";

// export default function Footer() {
//   return (
//     <section>
//       <footer id="contact-us" className="bg-[#1e1e1e] text-center text-white px-[20px] md:px-[50px] mx-auto py-10">
//         <div className="flex w-full items-start md:w-[92%] mx-auto">
//           <Link href="/">
//             <div
//               className="
//             mb-4 flex items-start text-2xl items-center cursor-pointer text-white hover:text-opacity-[0.7] font-bold mt-2"
//             >
//               <div className="w-6 mr-2">
//                 <Image src="/logo.png" alt="logo" height="51" width="30" />
//               </div>
//               itmtb
//             </div>
//           </Link>
//         </div>

//         <div className="grid grid-cols-2 md:grid-cols-4 gap-y-10 gap-x-10 my-8">
//           {[capabilitiesNav, industriesNav, generalPage, contactLinks].map((navList, idx) => {
//             return (
//               <div key={idx} className="flex flex-col space-y-2 items-start md:mx-auto ">
//                 <p className="text-[20px] mb-1 font-semibold text-gray-100/40">{navList[0].category}</p>
//                 {navList.map(item => {
//                   return (
//                     <Link key={item.link} href={item.link}>
//                       <a
//                         target={item.link.includes("https:") ? "_blank" : "_self"}
//                         className="text-left text-sm md:text-md hover:opacity-[0.6] cursor-pointer text-white"
//                       >
//                         {item.name}
//                       </a>
//                     </Link>
//                   );
//                 })}
//               </div>
//             );
//           })}
//         </div>
//         <div className="text-left my-10 sm:ml-4">
//           <p className="text-gray-100/40">Locations</p>
// 		  Pune | Mumbai | Bhopal
//           <p className="text-gray-100/40">Email</p>
// 	 hello@itmtb.com
//         </div>
//         <p className="text-sm">Copyright © {new Date().getFullYear()} Itmtb Technologies Private Limited</p>
//       </footer>
//     </section>
//   );
// }

// const contactLinks = [
//   {
//     name: "Contact Us",
//     link: "/contact-us",
//     category: "Get in Touch",
//   },
//   {
//     name: "LinkedIn",
//     link: "https://www.linkedin.com/company/itmtb/",
//   },
//   {
//     name: "Instagram",
//     link: "https://www.instagram.com/itmtbtech/",
//   },
// ];

// const generalPage = [
//   {
//     name: "About Us",
//     link: "/discover-itmtb",
//     category: "Others",
//   },
//   {
//     name: "Privacy Policy",
//     link: "/privacy_policy.html",
//   },
//   {
//     name: "Careers",
//     link: "/career",
//   },
// ];
